// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3isDo","bigColWidth":"Table_bigColWidth__2IiWH","biggerColWidth":"Table_biggerColWidth__i7Gx0","row":"Table_row__E8bXx","col":"Table_col__3DZIx"};